import useQuickButtons from "../../../../../hooks/useQuickButtons";
import { Cafe } from "../../../../../api/types";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { navigationTargetState } from "../../../../../recoil/store";
import { getKoreanNumber, getDistanceKm } from "../../../../../utils/common";
import { getGameTypeString } from "../../../../../utils/constants";
import { useEffect, useState } from "react";
import { geoCoordState } from "../../../../../recoil/geo";
import {
  Backdrop,
  PubMoreWrapper,
  InfoSection,
  TagRow,
  TagBox,
  Tag,
  CloseButton,
  TitleRow,
  CafeName,
  Address,
  InfoRow,
  InfoItem,
  InfoIcon,
  InfoText,
  MenuWrapper,
  MenuItem,
  MenuIcon,
  MenuLabel,
} from "./styles";

interface PubMoreProps {
  cafe: Cafe;
  setShowMoreOption: (value: boolean) => void;
  setSelectedStore: (value: Cafe | null) => void;
  showMoreOption: boolean;
}

const FranchiseMore = ({
  cafe,
  setShowMoreOption,
  setSelectedStore,
  showMoreOption,
}: PubMoreProps) => {
  const { openPhoneCall, toggleLike, shareLink } = useQuickButtons();
  const setNavigationTarget = useSetRecoilState(navigationTargetState);
  const { latitude, longitude } = useRecoilValue(geoCoordState);
  const [like, setLike] = useState(false);
  useEffect(() => {
    setLike(cafe.like);
  }, []);
  return (
    <>
      {showMoreOption && (
        <Backdrop
          onClick={() => {
            setShowMoreOption(false);
            setSelectedStore(null);
          }}
        />
      )}
      <PubMoreWrapper>
        <InfoSection>
          <TagRow>
            <TagBox>
              <Tag>{getGameTypeString(cafe.gameTypes)}</Tag>
              {cafe.buyIn && (
                <Tag>
                  바이인 : {getKoreanNumber(cafe.buyIn)} ~{" "}
                  {cafe.buyInMax ? getKoreanNumber(cafe.buyInMax) : ""}
                </Tag>
              )}
            </TagBox>
            <CloseButton
              src="/image-web/Holdem%20Now/Icon/Close.svg"
              alt="닫기"
              onClick={() => {
                setShowMoreOption(false);
                setSelectedStore(null);
              }}
            />
          </TagRow>

          <TitleRow>
            <CafeName>{cafe.cafeName}</CafeName>
          </TitleRow>

          <Address>
            {cafe.newAddress} {cafe.detailAddress}
          </Address>

          <InfoRow>
            <InfoItem>
              <InfoIcon src="/image-web/Icon/Heart/small.svg" alt="좋아요" />
              <InfoText>{cafe.likeCount}</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoIcon src="/image-web/Icon/Map%20pin/small.svg" alt="거리" />
              <InfoText>
                {getDistanceKm(latitude, longitude, cafe.lat, cafe.lon)} km
              </InfoText>
            </InfoItem>
          </InfoRow>
        </InfoSection>

        <MenuWrapper>
          <MenuItem
            onClick={() => {
              setShowMoreOption(false);
              setSelectedStore(null);
              openPhoneCall(
                cafe.cafeName,
                cafe.vcn ? cafe.vcn : cafe.phoneNumber
              );
            }}
          >
            <MenuIcon src="/image-web/search/Icon/phone.svg" alt="전화" />
            <MenuLabel>전화</MenuLabel>
          </MenuItem>

          <MenuItem
            onClick={async () => {
              await toggleLike(cafe?.id!, "CAFE");
              setLike(!like);
            }}
          >
            <MenuIcon
              src={`/image-web/search/Icon/${like ? "like_on" : "like"}.svg`}
              alt="즐겨찾기"
            />
            <MenuLabel>즐겨찾기</MenuLabel>
          </MenuItem>

          <MenuItem
            onClick={() => {
              setShowMoreOption(false);
              setSelectedStore(null);
              setNavigationTarget(cafe);
            }}
          >
            <MenuIcon src="/image-web/store/Navigation.svg" alt="길안내" />
            <MenuLabel>길안내</MenuLabel>
          </MenuItem>

          <MenuItem
            onClick={() => {
              shareLink(`/store/${cafe.id}?type=PREMIUM`);
            }}
          >
            <MenuIcon src="/image-web/store/Share.svg" alt="공유" />
            <MenuLabel>공유</MenuLabel>
          </MenuItem>
        </MenuWrapper>
      </PubMoreWrapper>
    </>
  );
};

export default FranchiseMore;
